"use strict";

exports.__esModule = true;
exports.range = range;

function range(num, min, max) {
  return Math.min(Math.max(num, min), max);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant/lib/utils/format/number.js
// module id = 7YUF
// module chunks = 0